import React, { ReactNode } from 'react'

import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'

import classes from './index.module.scss'
import { BaseInput } from '../base-input'

interface ReduxFormInputTwoProps {
  type?: string
  label?: ReactNode
  input: { name: string } & Record<string, unknown>
  meta: { error?: string | string[]; submitFailed?: boolean; touched?: boolean }
  help?: ReactNode
  id?: string
  showToggle: ReactNode
  dataTestId?: string
}

const ReduxFormInputTwo = ({
  type,
  label,
  input,
  meta: { error, submitFailed, touched },
  help,
  id = input.name,
  showToggle,
  dataTestId,
}: ReduxFormInputTwoProps) => {
  const isValid = isNil(error) || isEmpty(error)
  const showError = (submitFailed || touched) && !isValid

  const component = (
    <input
      id={id}
      {...input}
      type={type}
      className={showError ? classes.inputWithError : classes.inputNormal}
      data-testid={dataTestId}
    />
  )

  return BaseInput({
    component,
    errors: error ? (Array.isArray(error) ? error : [error]) : undefined,
    help,
    id,
    label,
    touched,
    submitFailed,
    dataTestId,
    showToggle,
    componentStyle: 'two',
  })
}

export { ReduxFormInputTwo }
export default ReduxFormInputTwo
